import React, {Component} from 'react';
import {Row, Col } from "reactstrap";
import {inject, observer} from "mobx-react/index";
import CardDetalhe from "../../comum/components/CardDetalhe";
import {listEmailFormatter} from "../../../utils/formatar"

@inject("store")
@observer
export default class DetalhesCargaGeral extends Component {
    constructor(props) {
        super(props);
    }

    formatarData(dataISO) {
        if (dataISO == '0001-01-01T00:00:00') return null;
        let d = new Date(dataISO);
        let dia = ('0' + d.getDate()).slice(-2);
        let mes = ('0' + (d.getMonth() + 1)).slice(-2);
        let ano = d.getFullYear();
        let horas = ('0' + d.getHours()).slice(-2);
        let minutos = ('0' + d.getMinutes()).slice(-2);      
        return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
    }

    formatarUtilizado(util){

        switch (util) {
            case 'Sim' : return 'Este agendamento já foi utilizado' 
            default : return null;

        }

    }
    

    render() {
        return (
            <Col xs={12} className="container-card-detalhe">
                <div className="pb-3 pt-3">
                    <h4>{this.props.titulo}</h4>
                    <Row className="m-0 no-gutters">
                    <Col sm={4}>
                            <CardDetalhe titulo={"Email"}
                                         desc={[this.props.row.EmailCriador]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Criado por"}
                                         desc={[this.props.row.UsuarioCriacao]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Data de Criação"}
                                         desc={[this.formatarData(this.props.row.DataCriacao)]}
                                         pt="pt-2"
                                         pb="pb-2"
                            />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Inativado por"}
                                         desc={[this.props.row.UsuarioCancelamento]}
                                         pt="pt-2"
                                         pb="pb-2"
                                         />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Data de Inativação"}
                                         desc={[this.formatarData(this.props.row.DataCancelamento)]}
                                         pt="pt-2"
                                         pb="pb-2"
                                         />
                        </Col>
                        <Col sm={4}>
                            <CardDetalhe titulo={"Observação"}
                                         desc={[this.formatarUtilizado(this.props.row.Utilizado)]}
                                         pt="pt-2"
                                         pb="pb-2"
                                         />
                        </Col>
                    </Row>
                </div>
            </Col>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/DetalhesCargaGeral.js